import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

const BillingContext = createContext({ usdPerEcu: 0.189, loaded: false });

export function BillingProvider({ children }) {
  const { data } = useQuery({
    queryKey: ["agent-usd-rate"],
    queryFn: async () => {
      // CEO endpoint is cheaper; falls back silently when not logged in.
      try {
        const r = await api.get("/settings/billing");
        return { usdPerEcu: r.data.usd_per_ecu };
      } catch {
        return { usdPerEcu: 0.189 };
      }
    },
    refetchInterval: 60000,
    staleTime: 55000,
  });

  const value = {
    usdPerEcu: data?.usdPerEcu ?? 0.189,
    loaded: !!data,
  };
  return <BillingContext.Provider value={value}>{children}</BillingContext.Provider>;
}

export function useBilling() {
  return useContext(BillingContext);
}
